import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Meconsteel88 Co</h3>
            <p>Professional construction and steel fabrication services</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#about">About</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Architectural Design and Planning</a></li>
              <li><a href="#services">General Contracting</a></li>
              <li><a href="#services">Structural Works</a></li>
              <li><a href="#services">Fit-Out Works and Finishing Works</a></li>
              <li><a href="#services">ADS</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="https://www.facebook.com/meconsteel88co" target="_blank" rel="noopener noreferrer">Facebook</a>
              <a href="https://www.instagram.com/meconsteel88co/" target="_blank" rel="noopener noreferrer">Instagram</a>
              <a href="https://maps.app.goo.gl/rvLQNLY5DiCK3D8DA" target="_blank" rel="noopener noreferrer">Our Location</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2026 Meconsteel88 Co. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
